
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import RadioButton from '@/components/radio-button.vue';
	import PickerDate from '@/components/picker-date.vue';
	import Dialog from '@/components/dialog.vue';
  import {
    memberRecommendNoStatisticslist,
    memberRecommendNoStatisticschange,
    memberRecommendNoQuotaChangeRecordlist
  } from "@/api/agent_user"
  import {
    getSearchDate,
    nextDay
  } from "@/utils"
  import {
    defaultHeader
  } from "@/utils/config"
  @Component({  
    name: '',
    components: {
      PageFooter,
      RadioButton,
      PickerDate,
			'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    private radioList = [
      {value:1,label:'邀请码统计'},
      {value:2,label:'变动明细'},
    ]
    private radioType = 1
    private keywords = ''
    private grade = null
    private gradeList = [
      {
        label: '全部',
        value: null
      },{
        label: 'VIP',
        value: 3
      }, {
        label: 'VIC',
        value: 2
      }, {
        label: 'SVIC',
        value: 1
      }, 
    ]
    private tablelist:any = []
    private tablelist2:any = []
    private tableloading = false
    private pageNo = 1
		private pageSize = 20
		private total = 0
    private rowmsg:any = {}
    private adjustShow = false
    private adjustLoading = false

    private keywords2 = ''
    private changeType = null
    private changeTypelist = [
      {value:null,label:'全部'},
      {value:1,label:'增加'},
      {value:2,label:'扣减'},
      {value:3,label:'后台增加'},
      {value:4,label:'后台扣减'},
    ]
    private changeTime = ''
    private defaultHeader = defaultHeader

    private mounted () {
      this.initTime()
      this.gettablelist()
    }




    private initTime(){
      this.changeTime = [getSearchDate(1)[0],getSearchDate(0)[0]].join('/')
    }
    private async getrecordlist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords2,
          RecordType:this.changeType,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
        }
        if(this.changeTime){
          let time = this.changeTime.split('/')
          data.StartTime = time[0]
          data.EndTime = nextDay(time[1],1)
        }
        let res = await memberRecommendNoQuotaChangeRecordlist(data)
        if(res.IsSuccess){
          this.tablelist2 = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private async confirm(){
      if(!this.rowmsg.ChangeQuota){
        this.$message.error('请输入调整数量')
        return
      }
      if(this.rowmsg.ChangeQuota<1||this.rowmsg.ChangeQuota>99999){
        this.$message.error('请输入1~99999的整数')
        return
      }
      if(this.rowmsg.RecordType==4&&this.rowmsg.ChangeQuota>this.rowmsg.SurplusRecommendNoQuota){
        this.$message.error('扣减数量超出用户持有的数量')
        return
      }
      if(!this.rowmsg.Remark){
        this.$message.error('请输入原因')
        return
      }
      try{
        this.adjustLoading = true
        let res = await memberRecommendNoStatisticschange(this.rowmsg)
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.adjustShow = false
          this.gettablelist()
        }
      }finally{
        this.adjustLoading = false
      }
    }
    private toAdjust(row){
      this.rowmsg = {
        MemberId:row.Id,
        RecordType:3,
        ChangeQuota:'',
        Remark:'',
        nowCount:row.SurplusRecommendNoQuota
      }

      this.adjustShow = true
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res = await memberRecommendNoStatisticslist({
          Keywords:this.keywords,
          RoleGrade:this.grade,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private changePage(e){
      this.pageNo = e
      if(this.radioType==1){
        this.gettablelist()
      }else{
        this.getrecordlist()
      }
    }
    private clearSearch(){
      if(this.radioType==1){
        this.keywords = ''
        this.grade = null
      }else{
        this.keywords2 = ''
        this.changeType = null
        this.initTime()
      }
      this.changePage(1)
    }
    private exportfile(){
      let url = location.origin
      if(this.radioType==1){
        url += '/pc/memberRecommendNoStatistics/export?'
        url += 'Keywords='+encodeURIComponent(this.keywords)
        url += '&RoleGrade='+(this.grade==null?'':this.grade)
      }else{
        url += '/pc/memberRecommendNoQuotaChangeRecord/export?'
        url += 'Keywords='+encodeURIComponent(this.keywords2)
        url += '&RecordType='+(this.changeType==null?'':this.changeType)
        if(this.changeTime){
          let time = this.changeTime.split('/')
          url += '&StartTime ='+time[0]
          url += '&EndTime ='+nextDay(time[1],1)
        }
      }

      window.open(url)
    }
    private handleChange(e){
      // console.log(e)
      this.changePage(1)
    }
  }
